import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, TouchableOpacity, View } from "react-native";
import AudioPlaceholder from "../AudioPlaceholder";

// Shared cloned-voice control used by BOTH the "Agent capabilities" section
// (voice-over) and the "Hosting & models" section (live voice pipeline).
// It reads/writes nothing itself — all state and handlers are passed in so
// both instances stay in sync through the parent's shared formik fields
// (voiceName / ttsModel / voiceFileKey).
const ClonedVoiceControl = ({
  isActive,
  isCloneInProgress,
  audioPath,
  onFileSelection,
  onRecordPress,
  onRemove,
  fileUploadInProgress,
  fileUploadProgress,
  isRecording,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  return (
    <View>
      <AppText
        wrapperStyle={{
          paddingHorizontal: 10,
          marginTop: 15,
          marginBottom: 5,
        }}
        style={{
          fontWeight: "bold",
          fontSize: currentTheme?.theme?.small_font_size,
        }}
        color={currentTheme?.theme?.font_color}
      >
        {t("settings.qa.audioGenerationClonedVoice")}
      </AppText>
      <AppText
        wrapperStyle={{
          paddingHorizontal: 10,
          marginBottom: -20,
        }}
        style={{
          fontSize: currentTheme?.theme?.extra_small_font_size,
        }}
        color={currentTheme?.theme?.mediumGrey}
      >
        {t("settings.qa.audioGenerationClonedVoiceDesc")}
      </AppText>
      <AudioPlaceholder
        audioPath={audioPath}
        onFileSelection={onFileSelection}
        isFileUploadInProgress={fileUploadInProgress}
        fileUploadProgress={fileUploadProgress}
        isVoiceRecordingInProgress={isRecording}
      >
        {isCloneInProgress ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              paddingHorizontal: 12,
              paddingVertical: 8,
              borderRadius: 8,
              backgroundColor: currentTheme?.theme?.primary,
            }}
          >
            <ActivityIndicator
              size="small"
              color={currentTheme?.theme?.white}
            />
            <AppText
              preventTranslation
              style={{
                fontSize: currentTheme?.theme?.extra_small_font_size,
                fontWeight: "500",
              }}
              color={currentTheme?.theme?.white}
            >
              {t("settings.qa.voiceCloneInProgressCaption")}
            </AppText>
          </View>
        ) : (
          <TouchableOpacity
            onPress={onRecordPress}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              paddingHorizontal: 12,
              paddingVertical: 8,
              borderRadius: 8,
              backgroundColor: currentTheme?.theme?.primary,
            }}
          >
            <AppIcon
              icon={AppAssets?.icons?.microphone}
              size={14}
              color={currentTheme?.theme?.white}
            />
            <AppText
              preventTranslation
              style={{
                fontSize: currentTheme?.theme?.extra_small_font_size,
                fontWeight: "500",
              }}
              color={currentTheme?.theme?.white}
            >
              {t("settings.qa.cloneVoice")}
            </AppText>
          </TouchableOpacity>
        )}
      </AudioPlaceholder>
      {isActive && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            marginHorizontal: 10,
            marginBottom: 10,
            marginTop: 10,
            paddingHorizontal: 10,
            paddingVertical: 8,
            borderRadius: 8,
            backgroundColor:
              currentTheme?.theme?.buttonBackgroundColor ||
              currentTheme?.theme?.lightGrey,
            borderLeftWidth: 3,
            borderLeftColor: currentTheme?.theme?.primary,
            opacity: audioPath ? 1 : 0.6,
          }}
        >
          <AppIcon
            icon={AppAssets?.icons?.microphone}
            size={12}
            color={currentTheme?.theme?.primary}
          />
          <AppText
            style={{
              flex: 1,
              fontSize: currentTheme?.theme?.extra_small_font_size,
            }}
            color={currentTheme?.theme?.font_color}
          >
            {t("settings.qa.clonedVoiceActiveCaption")}
          </AppText>
          {onRemove && (
            <TouchableOpacity
              onPress={onRemove}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            >
              <AppIcon
                icon={AppAssets?.icons?.delete}
                size={14}
                color={
                  currentTheme?.theme?.red || currentTheme?.theme?.orange
                }
              />
            </TouchableOpacity>
          )}
        </View>
      )}
    </View>
  );
};

export default ClonedVoiceControl;
